export default "__VITE_ASSET__jmJ0GBOC__"